import React from 'react'
import { AlertBox } from '@mobi/component-library/Overlays/AlertBox'
import { CustomerServiceTelephone } from '@mobi/component-library/Base/Link'
import { FeatureIcon } from '@mobi/component-library/Assets/Icon'
import { font, spacing } from '@mobi/component-library/Foundations'

interface SignupErrorProps {
  isOpen: boolean
  applicationNumber?: number
  onClose: () => void
}

export const SignupError: React.FC<SignupErrorProps> = ({ isOpen, applicationNumber, onClose }) => {
  return (
    <AlertBox
      icon={<FeatureIcon type='error' size='xl' />}
      isOpen={isOpen}
      title='Sorry, an error occurred!'
      text={
        <div>
          There was an error in creating your account. Please contact us on{' '}
          <CustomerServiceTelephone />{' '}
          {(applicationNumber ?? 0) > 0 && 'and provide the following Application ID '}
          so we can assist you in completing your registration.
          {(applicationNumber ?? 0) > 0 && (
            <div style={{ marginTop: spacing.md, fontWeight: font.weight.medium }}>
              Application ID: {applicationNumber}
            </div>
          )}
        </div>
      }
      confirmText='Close'
      onConfirm={onClose}
      actionOrientation='vertical'
      alignLeft
    />
  )
}
